import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter } from "react-router"
import { App } from "./App"
import "./styles/globals.css"
import "@audra/marketing-ui/styles.css"

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)












